let title = ' | Gestor - Comercial Ivaiporã'

const contrato = {
    path: '/contrato',
    props: true,
    component: () => import('@/Components/Contrato/ContratoContainer'),
    children: [
        {
            path: '',
            name: 'ContratoLista',
            component: () => import('@/Components/Contrato/ContratoLista'),
            meta: {
                title: 'Contratos' + title,
                permission: 'contrato_listar',
                breadcrumb: [
                    {
                        text: 'Início',
                        exact: true,
                        link: true,
                        disabled: false,
                        to: '/',
                    },
                    {
                        text: 'Contratos',
                        exact: true,
                        link: true,
                        disabled: true,
                        to: '/contrato',
                    }
                ]
            }
        },
        {
            path: '/assinaturas',
            name: 'ContratoCadastraAssinatura',
            component: () => import('@/Components/Contrato/ContratoCadastraAssinatura.vue'),
            meta: {
                title: 'Assinaturas' + title,
                permission: 'contrato_assinaturas_listar',
                breadcrumb: [
                    {
                        text: 'Início',
                        exact: true,
                        link: true,
                        disabled: false,
                        to: '/',
                    },
                    {
                        text: 'Assinaturas',
                        exact: true,
                        link: true,
                        disabled: true,
                        to: '/assinaturas',
                    }
                ]
            }
        },
        {
            path: '/permissao_terceiros',
            name: 'ContratoPermissaoTerceiros',
            component: () => import('@/Components/Contrato/ContratoPermissaoTerceiros.vue'),
            meta: {
                title: 'Permissão para Terceiros' + title,
                permission: 'contrato_terceiros_listar',
                breadcrumb: [
                    {
                        text: 'Início',
                        exact: true,
                        link: true,
                        disabled: false,
                        to: '/',
                    },
                    {
                        text: 'Permissão para Terceiros',
                        exact: true,
                        link: true,
                        disabled: true,
                        to: '/permissao_terceiros',
                    }
                ]
            }
        },
        {
            path: 'get/:idcontrato',
            props: true,
            name: 'ContratoGet',
            component: () => import('@/Components/Contrato/ContratoGet'),
            meta: {
                title: 'Contrato' + title,
                permission: 'contrato_get',
                breadcrumb: [
                    {
                        text: 'Início',
                        exact: true,
                        link: true,
                        disabled: false,
                        to: '/',
                    },
                    {
                        text: 'Contratos',
                        exact: true,
                        link: true,
                        disabled: false,
                        to: '/contrato',
                    },
                    {
                        text: 'Contrato',
                        exact: true,
                        link: true,
                        disabled: true,
                        to: '',
                    }
                ]
            }
        },
        {
            path: '/logs',
            props: true,
            name: 'ContratoLogs',
            component: () => import('@/Components/Contrato/ContratoLogs'),
            meta: {
                title: 'Contrato' + title,
                permission: 'contrato_logs',
                breadcrumb: [
                    {
                        text: 'Início',
                        exact: true,
                        link: true,
                        disabled: false,
                        to: '/',
                    },
                    {
                        text: 'Logs',
                        exact: true,
                        link: true,
                        disabled: true,
                        to: '/logs',
                    }
                ]
            }
        }
    ]
}

export default contrato